import { gql, useQuery } from "@apollo/client";
import React, { useState } from "react";
import { getUsers } from "../../graphql/querys";
function LoginPage() {
  const { loading, error, data } = useQuery(getUsers);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [wrong, setWrong] = useState(false);
  const handleSubmit = (event) => {
    if (
      data.users.find(
        (val, ind) => val.email == username && val.password == password
      )
    ) {
      setWrong(false);
      window.location.href = "/app/events";
      return;
    }
    setWrong(true);
    // TODO: Implement login logic
  };

  return (
    <div className="LoginPage">
      {loading ? (
        "Loading"
      ) : (
        <div className="form">
          <h1>Login</h1>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </div>
          <div className="form-group">
            {wrong ? (
              <label style={{ color: "red", fontSize: "0.7em" }}>
                Wrong Password or Username
              </label>
            ) : (
              ""
            )}
          </div>
          <button onClick={handleSubmit}>Login</button>
        </div>
      )}
    </div>
  );
}

export default LoginPage;
